import React from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { onChange, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            code: props.code,
            comment: { name: 'comment', value: '', error: '', isRequired: true },
        }
    }

    render() {
        const { comment } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Comments <sup>*</sup></label>
                                        <textarea
                                            rows={5}
                                            className={comment.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder="Enter your message here"
                                            name={comment.name}
                                            value={comment.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.toggleModal} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                                </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const st = this.state;
            const model = {
                code: st.code,
                comment: st.comment.value,
            };

            this.props.onSubmit(model);
        }
    }
}

export default ComponentName;